<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-arrow-insert`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.47 15.01l.138-.01.203.02c.28.033.539.13.755.282l13.445 7.259c.557.298 1.082.882.975 1.439.107.557-.418 1.14-.975 1.44l-13.445 7.258a1.66 1.66 0 01-.755.283l-.106.01c-.033.002-.064.009-.097.009l-.058-.005a1.67 1.67 0 01-.238-.023c-.468-.086-.857-.324-1.09-.7l-.038-.072-.067-.144-.026-.072-.022-.072a1.555 1.555 0 01-.045-.182l-.02-.158A.793.793 0 0129 31.5V26H3a1 1 0 01-1-1v-2a1 1 0 011-1h26v-5.5c0-.073.012-.142.023-.211l.029-.14.017-.06c.014-.05.029-.097.048-.145l.035-.072c.022-.048.04-.097.07-.144a1.558 1.558 0 011.048-.694c.081-.013.143-.02.2-.025z"/></svg>
</template>
<script>

export default {
  name: 'IconArrowInsert',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
